export function b64encode(value) {
    return btoa(String.fromCharCode(...new TextEncoder().encode(value)));
}

export function b64decode(value) {
    const standard = value.replace(/-/g, '+').replace(/_/g, '/');
    return new TextDecoder().decode(Uint8Array.from(atob(standard), (character) => character.charCodeAt(0)));
}

export function isGuid(str){  
    // Define a regular expression pattern for a valid GUID
    const guidPattern =
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

    // Test if the string matches the pattern
    return guidPattern.test(str);  
}

export function convertGuidsToBase64(obj) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];

      // Check if the value is of type "guid"
      if (
        typeof value === "string" &&
        value.match(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
        )
      ) {
        // Convert the GUID to base64 using the b64encode method
        obj[key] = b64encode(value);
      } else if (typeof value === "object") {
        // If the value is an object, recursively call the function on it
        convertGuidsToBase64(value);
      }
    }
  }
}
